export default "__VITE_ASSET__DizXoGdy__"